<template>
  <b-modal
    id="modal-detail-historical-internal-memo"
    size="xl"
    :title="`Historical Log Detail Internal Memo - ${activity}`"
    @hide="resetModal()"
    @show="showModal()"
    hide-footer
  >
    <div class="container-fluid">
      <div v-if="isLoading" class="row mb-3">
        <!-- Skeleton loader, misalnya tampilkan placeholder -->
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <!-- Tambahkan skeleton untuk seluruh konten yang memerlukan data -->
      </div>

      <div v-else>
        <!-- Bagian Header -->
        <div class="card">
          <div class="card-body">
            <h4>Activity Description</h4>
            <p>{{ this.activityDescription }}</p>
          </div>
        </div>
        <!-- Update Value Section -->
        <div v-if="activity !== 'Delete'" class="card mb-1">
          <div class="card-header">
            <h4 class="card-header-title">Detail Changes</h4>
          </div>
          <div class="card-body" v-if="hasComparisonData || hasChangesAttach || hasChangesDepartment">
            <div v-for="(field, key) in comparisonData" :key="key" class="row align-items-center mb-2">
              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-warning p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>Old Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>

                  <div v-if="key === 'Departments' && Array.isArray(field.old_value)">
                    <table class="table table-responsive">
                      <tr>
                        <th>Code</th>
                        <th>Name</th>
                      </tr>
                      <tr v-for="(dept, index) in field.old_value" :key="dept.id || index">
                        <td>{{ dept.department_code }}</td>
                        <td>{{ dept.department_name }}</td>
                      </tr>
                    </table>
                  </div>

                  <div v-else>
                    <span v-if="key === 'Relocate Value'">
                      <p class="mb-0">{{ formatCurrency(field.old_value) }}</p>
                    </span>
                    <span v-else>
                      <p class="mb-0">{{ field.old_value }}</p>
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-2 text-center">
                <i class="fe fe-arrow-right fs-3 text-primary"></i>
              </div>

              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-info p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>New Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>

                  <div v-if="key === 'Departments' && Array.isArray(field.new_value)">
                    <table class="table table-responsive">
                      <tr>
                        <th>Code</th>
                        <th>Name</th>
                      </tr>
                      <tr v-for="(dept, index) in field.new_value" :key="dept.id || index">
                        <td>{{ dept.department_code }}</td>
                        <td>{{ dept.department_name }}</td>
                      </tr>
                    </table>
                  </div>

                  <div v-else>
                    <span v-if="key === 'Relocate Value'">
                      <p class="mb-0">{{ formatCurrency(field.new_value) }}</p>
                    </span>
                    <span v-else>
                      <p class="mb-0">{{ field.new_value }}</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- changes department -->
            <div v-for="(field, key, index) in changesAttach" :key="key" class="row align-items-center mb-2">
              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-warning p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>Old Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>
                  <p class="mb-0">{{ field.old_value }}</p>
                </div>
              </div>

              <div class="col-md-2 text-center">
                <i class="fe fe-arrow-right fs-3 text-primary"></i>
              </div>

              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-info p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>New Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>
                  <p class="mb-0">{{ field.new_value }}</p>
                </div>
              </div>
            </div>
            <div v-for="(field, key) in changesDepartment" :key="key" class="row align-items-center mb-2">
              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-warning p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>Old Data</strong>
                    </div>
                  </div>
                  <p class="mb-0">{{ field.old_value }}</p>
                </div>
              </div>

              <div class="col-md-2 text-center">
                <i class="fe fe-arrow-right fs-3 text-primary"></i>
              </div>

              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-info p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>New Data</strong>
                    </div>
                  </div>
                  <p class="mb-0">{{ field.new_value }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body mb-1 mt-1" v-if="projectDeleted && projectDeleted.length > 0">
            <div class="card border border-danger mb-1 mt-1">
              <div class="card-header">
                <h4 class="card-header-title">Deleted</h4>
              </div>
              <div class="card-body m-1 p-1">
                <div v-for="(field, key) in projectDeleted" :key="key" class="card m-3 p-3">
                  <div>
                    <div class="row">
                      <div class="ml-2 pl-2">
                        <label class="header"> Project Name: </label>
                        {{ field.project_name }}
                      </div>
                      <div class="row" v-for="(itemRelocate, keyRelocate) in field?.project_relocations">
                        <div class="col-md-6">
                          <div class="card">
                            <div class="card-header">
                              <h4 class="card-header-title">From</h4>
                            </div>
                            <div class="card-body">
                              <div class="card p-3 rounded m-3 p-3">
                                <span>
                                  <label> Departmen : </label>
                                  {{ itemRelocate?.budget_task_from_detail?.department_name }}
                                </span>
                                <span>
                                  <label> Plan : </label>
                                  {{ itemRelocate?.budget_task_from_detail?.plan_title }}, {{ itemRelocate?.budget_task_from_detail?.plan_year }},
                                  {{ itemRelocate?.budget_task_from_detail?.plan_version }}
                                </span>
                                <span>
                                  <label> GL : </label>
                                  {{
                                    `${itemRelocate?.budget_task_from_detail?.budget_type} - ${itemRelocate?.budget_task_from_detail?.fund_name} - ${itemRelocate?.budget_task_from_detail?.gl_code} - ${itemRelocate?.budget_task_from_detail?.account_name}`
                                  }}
                                </span>
                                <span>
                                  <label> Budget Task : </label>
                                  {{ `${itemRelocate?.budget_task_from_detail?.name}` }}
                                </span>
                                <span>
                                  <label> Relocation Value : </label>
                                  {{ `${itemRelocate?.relocate_value}` }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="card">
                            <div class="card-header">
                              <h4 class="card-header-title">To</h4>
                            </div>
                            <div class="card-body">
                              <div class="card p-3 m-3 p-3">
                                <span>
                                  <label> Departmen : </label>
                                  {{ itemRelocate?.budget_task_to_detail?.department_name }}
                                </span>
                                <span>
                                  <label> Plan : </label>
                                  {{ itemRelocate?.budget_task_to_detail?.plan_title }}, {{ itemRelocate?.budget_task_to_detail?.plan_year }},
                                  {{ itemRelocate?.budget_task_to_detail?.plan_version }}
                                </span>
                                <span>
                                  <label> GL : </label>
                                  {{
                                    `${itemRelocate?.budget_task_to_detail?.budget_type} - ${itemRelocate?.budget_task_to_detail?.fund_name} - ${itemRelocate?.budget_task_to_detail?.gl_code} - ${itemRelocate?.budget_task_to_detail?.account_name}`
                                  }}
                                </span>
                                <span>
                                  <label> Budget Task : </label>
                                  {{ `${itemRelocate?.budget_task_to_detail?.name}` }}
                                </span>
                                <span>
                                  <label> Relocation Value : </label>
                                  {{ `${itemRelocate?.relocate_value}` }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body mb-1 mt-1" v-if="projectAdded && projectAdded.length > 0">
            <div class="card border border-info mb-1 mt-1">
              <div class="card-header">
                <h4 class="card-header-title">Added</h4>
              </div>
              <div class="card-body m-1 p-1">
                <div v-for="(field, key) in projectAdded" :key="key" class="card m-3 p-3">
                  <div>
                    <div class="row">
                      <div class="ml-2 pl-2">
                        <label class="header"> Project Name: </label>
                        {{ field.project_name }}
                      </div>
                      <div class="row" v-for="(itemRelocate, keyRelocate) in field?.project_relocations">
                        <div class="col-md-6">
                          <div class="card">
                            <div class="card-header">
                              <h4 class="card-header-title">From</h4>
                            </div>
                            <div class="card-body">
                              <div class="card p-3 rounded m-3 p-3">
                                <span>
                                  <label> Departmen : </label>
                                  {{ itemRelocate?.budget_task_from_detail?.department_name }}
                                </span>
                                <span>
                                  <label> Plan : </label>
                                  {{ itemRelocate?.budget_task_from_detail?.plan_title }}, {{ itemRelocate?.budget_task_from_detail?.plan_year }},
                                  {{ itemRelocate?.budget_task_from_detail?.plan_version }}
                                </span>
                                <span>
                                  <label> GL : </label>
                                  {{
                                    `${itemRelocate?.budget_task_from_detail?.budget_type} - ${itemRelocate?.budget_task_from_detail?.fund_name} - ${itemRelocate?.budget_task_from_detail?.gl_code} - ${itemRelocate?.budget_task_from_detail?.account_name}`
                                  }}
                                </span>
                                <span>
                                  <label> Budget Task : </label>
                                  {{ `${itemRelocate?.budget_task_from_detail?.name}` }}
                                </span>
                                <span>
                                  <label> Relocation Value : </label>
                                  {{ `${itemRelocate?.relocate_value}` }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="card">
                            <div class="card-header">
                              <h4 class="card-header-title">To</h4>
                            </div>
                            <div class="card-body">
                              <div class="card p-3 m-3 p-3">
                                <span>
                                  <label> Departmen : </label>
                                  {{ itemRelocate?.budget_task_to_detail?.department_name }}
                                </span>
                                <span>
                                  <label> Plan : </label>
                                  {{ itemRelocate?.budget_task_to_detail?.plan_title }}, {{ itemRelocate?.budget_task_to_detail?.plan_year }},
                                  {{ itemRelocate?.budget_task_to_detail?.plan_version }}
                                </span>
                                <span>
                                  <label> GL : </label>
                                  {{
                                    `${itemRelocate?.budget_task_to_detail?.budget_type} - ${itemRelocate?.budget_task_to_detail?.fund_name} - ${itemRelocate?.budget_task_to_detail?.gl_code} - ${itemRelocate?.budget_task_to_detail?.account_name}`
                                  }}
                                </span>
                                <span>
                                  <label> Budget Task : </label>
                                  {{ `${itemRelocate?.budget_task_to_detail?.name}` }}
                                </span>
                                <span>
                                  <label> Relocation Value : </label>
                                  {{ `${itemRelocate?.relocate_value}` }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body mb-1 mt-1" v-if="projectChanged && projectChanged.length > 0">
            <div class="card border border-warning mb-1 mt-1">
              <div class="card-header">
                <h4 class="card-header-title">Changes</h4>
              </div>
              <div class="card-body m-1 p-1">
                <div v-for="(field, key) in projectChanged" :key="key" class="card m-3 p-3">
                  <div>
                    <div class="row">
                      <div class="row">
                        <div class="col-md-6">
                          <label> Project Name: </label>
                          <p>{{ field.project_name }}</p>
                        </div>
                        <div class="col-md-6">
                          <label> Relocate Value: </label>
                          <p>{{ formatCurrency(field.relocate_value) }}</p>
                        </div>
                      </div>
                      <div class="row" v-for="(itemRelocate, keyRelocate) in field?.project_relocations">
                        <div class="card border border-primary m-3 p-3">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="card">
                                  <div class="card-header">
                                    <h4 class="card-header-title">From</h4>
                                  </div>
                                  <div class="card-body">
                                    <div class="card p-3 rounded m-3 p-3">
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.budget_task_from_detail?.department_name !==
                                            itemRelocate?.new_value?.budget_task_from_detail?.department_name
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          Departmen :
                                        </label>
                                        {{ itemRelocate?.budget_task_from_detail?.department_name }}
                                      </span>
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.budget_task_from_detail?.plan_title !==
                                              itemRelocate?.new_value?.budget_task_from_detail?.plan_title ||
                                            itemRelocate?.budget_task_from_detail?.plan_year !==
                                              itemRelocate?.new_value?.budget_task_from_detail?.plan_year ||
                                            itemRelocate?.budget_task_from_detail?.plan_version !==
                                              itemRelocate?.new_value?.budget_task_from_detail?.plan_version
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          Plan :
                                        </label>
                                        {{ itemRelocate?.budget_task_from_detail?.plan_title }},
                                        {{ itemRelocate?.budget_task_from_detail?.plan_year }},
                                        {{ itemRelocate?.budget_task_from_detail?.plan_version }}
                                      </span>
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.budget_task_from_detail?.budget_type !==
                                              itemRelocate?.new_value?.budget_task_from_detail?.budget_type ||
                                            itemRelocate?.budget_task_from_detail?.gl_code !==
                                              itemRelocate?.new_value?.budget_task_from_detail?.gl_code
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          GL :
                                        </label>
                                        {{
                                          `${itemRelocate?.budget_task_from_detail?.budget_type} - ${itemRelocate?.budget_task_from_detail?.fund_name} - ${itemRelocate?.budget_task_from_detail?.gl_code} - ${itemRelocate?.budget_task_from_detail?.account_name}`
                                        }}
                                      </span>
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.budget_task_from_detail?.name !== itemRelocate?.new_value?.budget_task_from_detail?.name
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          Budget Task :
                                        </label>
                                        {{ `${itemRelocate?.budget_task_from_detail?.name}` }}
                                      </span>
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.relocate_value !== itemRelocate?.new_value?.relocate_value
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          Relocation Value :
                                        </label>
                                        {{ `${itemRelocate?.relocate_value}` }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="card">
                                  <div class="card-header">
                                    <h4 class="card-header-title">To</h4>
                                  </div>
                                  <div class="card-body">
                                    <div class="card p-3 m-3 p-3">
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.budget_task_to_detail?.department_name !==
                                            itemRelocate?.new_value?.budget_task_to_detail?.department_name
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          Departmen :
                                        </label>
                                        {{ itemRelocate?.budget_task_to_detail?.department_name }}
                                      </span>
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.budget_task_to_detail?.plan_title !==
                                              itemRelocate?.new_value?.budget_task_to_detail?.plan_title ||
                                            itemRelocate?.budget_task_to_detail?.plan_year !==
                                              itemRelocate?.new_value?.budget_task_to_detail?.plan_year ||
                                            itemRelocate?.budget_task_to_detail?.plan_version !==
                                              itemRelocate?.new_value?.budget_task_to_detail?.plan_version
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          Plan :
                                        </label>
                                        {{ itemRelocate?.budget_task_to_detail?.plan_title }}, {{ itemRelocate?.budget_task_to_detail?.plan_year }},
                                        {{ itemRelocate?.budget_task_to_detail?.plan_version }}
                                      </span>
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.budget_task_to_detail?.budget_type !==
                                              itemRelocate?.new_value?.budget_task_to_detail?.budget_type ||
                                            itemRelocate?.budget_task_to_detail?.gl_code !== itemRelocate?.new_value?.budget_task_to_detail?.gl_code
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          GL :
                                        </label>
                                        {{
                                          `${itemRelocate?.budget_task_to_detail?.budget_type} - ${itemRelocate?.budget_task_to_detail?.fund_name} - ${itemRelocate?.budget_task_to_detail?.gl_code} - ${itemRelocate?.budget_task_to_detail?.account_name}`
                                        }}
                                      </span>
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.budget_task_to_detail?.name !== itemRelocate?.new_value?.budget_task_to_detail?.name
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          Budget Task :
                                        </label>
                                        {{ `${itemRelocate?.budget_task_to_detail?.name}` }}
                                      </span>
                                      <span>
                                        <label
                                          :class="
                                            itemRelocate?.relocate_value !== itemRelocate?.new_value?.relocate_value
                                              ? 'bg-danger text-white p-2 m-1'
                                              : ''
                                          "
                                        >
                                          Relocation Value :
                                        </label>
                                        {{ `${itemRelocate?.relocate_value}` }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-12 text-center mb-3">
                                <i class="fe fe-arrow-down fs-2 text-primary"></i>
                              </div>

                              <div class="col-md-6">
                                <div class="card">
                                  <div class="card-header">
                                    <h4 class="card-header-title">From</h4>
                                  </div>
                                  <div class="card-body">
                                    <div class="card p-3 rounded m-3 p-3">
                                      <span>
                                        <label> Departmen : </label>
                                        {{ itemRelocate?.new_value?.budget_task_from_detail?.department_name }}
                                      </span>
                                      <span>
                                        <label> Plan : </label>
                                        {{ itemRelocate?.new_value?.budget_task_from_detail?.plan_title }},
                                        {{ itemRelocate?.new_value?.budget_task_from_detail?.plan_year }},
                                        {{ itemRelocate?.new_value?.budget_task_from_detail?.plan_version }}
                                      </span>
                                      <span>
                                        <label> GL : </label>
                                        {{
                                          `${itemRelocate?.new_value?.budget_task_from_detail?.budget_type} - ${itemRelocate?.new_value?.budget_task_from_detail?.fund_name} - ${itemRelocate?.new_value?.budget_task_from_detail?.gl_code} - ${itemRelocate?.new_value?.budget_task_from_detail?.account_name}`
                                        }}
                                      </span>
                                      <span>
                                        <label> Budget Task : </label>
                                        {{ `${itemRelocate?.new_value?.budget_task_from_detail?.name}` }}
                                      </span>
                                      <span>
                                        <label> Relocation Value : </label>
                                        {{ formatCurrency(`${itemRelocate?.new_value?.relocate_value}`) }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="card">
                                  <div class="card-header">
                                    <h4 class="card-header-title">To</h4>
                                  </div>
                                  <div class="card-body">
                                    <div class="card p-3 m-3 p-3">
                                      <span>
                                        <label> Departmen : </label>
                                        {{ itemRelocate?.new_value?.budget_task_to_detail?.department_name }}
                                      </span>
                                      <span>
                                        <label> Plan : </label>
                                        {{ itemRelocate?.new_value?.budget_task_to_detail?.plan_title }},
                                        {{ itemRelocate?.new_value?.budget_task_to_detail?.plan_year }},
                                        {{ itemRelocate?.new_value?.budget_task_to_detail?.plan_version }}
                                      </span>
                                      <span>
                                        <label> GL : </label>
                                        {{
                                          `${itemRelocate?.new_value?.budget_task_to_detail?.budget_type} - ${itemRelocate?.new_value?.budget_task_to_detail?.fund_name} - ${itemRelocate?.new_value?.budget_task_to_detail?.new_value} - ${itemRelocate?.new_value?.budget_task_to_detail?.account_name}`
                                        }}
                                      </span>
                                      <span>
                                        <label> Budget Task : </label>
                                        {{ `${itemRelocate?.new_value?.budget_task_to_detail?.name}` }}
                                      </span>
                                      <span>
                                        <label> Relocation Value : </label>
                                        {{ formatCurrency(`${itemRelocate?.new_value?.relocate_value}`) }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="card mb-1">
          <div class="card-header">
            <h4 class="card-header-title">Detail Changes</h4>
          </div>
          <!--          <div class="card-body">
            <div v-for="(field, key) in comparisonData" :key="key" class="row align-items-center mb-2">
              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-warning p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>Old Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>
                  <p class="mb-0">{{ field.old_value }}</p>
                </div>
              </div>

              <div class="col-md-2 text-center">
                <i class="fe fe-arrow-right fs-3 text-primary"></i>
              </div>

              <div class="col-md-5">
                <div class="border p-3 rounded bg-white text-dark">
                  <div class="d-flex align-items-center">
                    <div class="mb-3 bg-info p-3 py-1 rounded fs-6" style="display: inline-block">
                      <strong>New Data</strong>
                    </div>
                    <div class="mb-3 text-primary p-3 py-1 rounded fs-4">
                      <strong>{{ key }}</strong>
                    </div>
                  </div>
                  <div v-if="field.new_value === 'Departments'"></div>
                  <div v-else>
                    <p class="mb-0">{{ field.new_value }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
        </div>
        <!-- End Detail changes -->

        <div v-if="this.imCategory === 'Pengajuan Khusus'">
          <b-tabs card pills fill>
            <b-tab :title="`Before`">
              <DetailPK :loadData="this.loadDetailPK" :dataDetail="this.oldValue" :oldData="this.oldData" />
            </b-tab>
            <b-tab :title="`After`">
              <DetailPK :loadData="this.loadDetailPK" :dataDetail="this.newValue" :oldData="this.oldData" />
            </b-tab>
          </b-tabs>
        </div>

        <div v-else>
          <b-tabs card pills fill>
            <b-tab :title="`Before`">
              <DetailBRS :loadData="this.loadDetailBRS" :dataDetail="this.oldValue" :oldData="this.oldData" />
            </b-tab>
            <b-tab :title="`After`">
              <DetailBRS :loadData="this.loadDetailBRS" :dataDetail="this.newValue" :oldData="this.oldData" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axiosIns from '@/api/axios';
import { formatCurrency } from '@/utils/formatNumber';
import moment from 'moment';
import DetailInternalMemoPK from '@/views/historicalLog/DetailInternalMemoPK.vue';
import DetailBRS from '@/views/historicalLog/DetailBRS.vue';
import DetailPK from '@/views/historicalLog/DetailPK.vue';

export default {
  components: { DetailPK, DetailBRS, DetailInternalMemoPK },
  props: {
    logId: Number,
    activity: String,
  },
  computed: {
    detail() {
      return this.logData?.oldData;
    },
    diffChanges() {
      if (!this.oldValue || !this.newValue) return [];
      return this.deepDiff(this.oldValue, this.newValue);
    },
    /*auditLogs() {
      return this.buildAuditLog(this.oldValue, this.newValue);
    },*/
    hasChangesDepartment() {
      return Object.keys(this.changesDepartment || {}).length > 0;
    },
    hasChangesAttach() {
      return Object.keys(this.changesAttach || {}).length > 0;
    },
    hasComparisonData() {
      return Object.keys(this.comparisonData || {}).length > 0;
    },
  },
  data() {
    return {
      projectDeleted: [],
      projectAdded: [],
      projectChanged: [],
      oldValue: [],
      newValue: [],
      activityDescription: '',
      oldData: '',
      imCategory: '',
      isLoading: true,
      loadDetailBRS: false,
      loadDetailPK: false,
      logData: {},
      comparisonData: {},
      changesDepartment: {},
      changesIMProjects: {},
      changesAttach: {},
    };
  },
  methods: {
    async showModal() {
      await this.fetchHistoricalLog();
    },
    resetModal() {
      this.logData = {};
      this.comparisonData = {};
      this.isLoading = true;
      this.loadDetailBRS = false;
      this.loadDetailPK = false;
      this.projectAdded = [];
      this.projectChanged = [];
      this.projectDeleted = [];
    },
    async fetchHistoricalLog() {
      if (!this.logId) return;
      this.resetModal();
      await axiosIns
        .get(`/historical-log/${this.logId}`)
        .then((response) => {
          const data = response.data.data;
          this.activityDescription = data?.detail?.activity_description ?? null;
          this.imCategory = data.detail?.oldData?.im_category || null;
          this.oldValue = data?.data_changes?.old_value ?? [];
          this.newValue = data?.data_changes?.new_value ?? [];
          this.oldData = data.detail?.oldData || null;
          this.isLoading = false;
          let tempOldValue = [];
          let tempNewValue = [];
          tempOldValue = {
            ...tempOldValue,
            name: data.data_changes.old_value?.name,
            im_number: data.data_changes.old_value?.im_number,
            im_category: data.data_changes.old_value?.im_category,
            im_year: data.data_changes.old_value?.im_year,
            relocate_value: data.data_changes.old_value?.relocate_value,
          };
          tempNewValue = {
            ...tempNewValue,
            name: data.data_changes.new_value?.name,
            im_number: data.data_changes.new_value?.im_number,
            im_category: data.data_changes.new_value?.im_category,
            im_year: data.data_changes.new_value?.im_year,
            relocate_value: data.data_changes.new_value?.relocate_value,
          };
          this.comparisonData = this.getComparisonDataCustome(tempOldValue, tempNewValue);
          this.deepDiffProject(data.data_changes.old_value?.im_projects || null, data.data_changes.new_value?.im_projects || null);

          const tempOldAttachments = (data.data_changes.old_value?.attachments || []).reduce((acc, d) => {
            acc[d.label] = d.filename;
            return acc;
          }, {});

          const tempNewAttachments = (data.data_changes.new_value?.attachments || []).reduce((acc, d) => {
            acc[d.label] = d.filename;
            return acc;
          }, {});
          this.changesAttach = this.getComparisonDataCustome(tempOldAttachments, tempNewAttachments);

          const tempOldDept =
            (data.data_changes.old_value?.departments || []).reduce((acc, d) => {
              acc[`${d.department_code}`] = d.department_name;
              return acc;
            }, {}) || {};

          const tempNewDept =
            (data.data_changes.new_value?.departments || []).reduce((acc, d) => {
              acc[`${d.department_code}`] = d.department_name;
              return acc;
            }, {}) || {};
          this.changesDepartment = this.getComparisonDataCustome(tempOldDept, tempNewDept);

          const tempOldIMProjects =
            (data.data_changes.old_value?.im_projects || []).reduce((acc, d) => {
              acc[`${d.project_name}`] = d.project_relocations;
              return acc;
            }, {}) || {};

          const tempNewIMProjects =
            (data.data_changes.new_value?.im_projects || []).reduce((acc, d) => {
              acc[`${d.project_name}`] = d.project_relocations;
              return acc;
            }, {}) || {};
          this.changesIMProjects = this.getComparisonData(tempOldIMProjects, tempNewIMProjects);
          if (this.imCategory === 'Pengajuan Khusus') {
            this.loadDetailPK = true;
          }
          if (this.imCategory === 'Budget Relocation Statement (BRS)') {
            this.loadDetailBRS = true;
          }
        })
        .catch((error) => {
          this.isLoading = true; // Stop loading if error occurs
          this.$swal('Error', error.response?.data?.error || 'Terjadi kesalahan, tidak dapat mengambil data.', 'error');
          this.resetModal();
          console.error('Error fetching historical log details:', error);
        });
    },
    formatDate(date, withTime = true) {
      if (withTime) {
        return date ? moment(date).format('DD MMMM YYYY HH:mm') : '-';
      }
      return date ? moment(date).format('DD MMMM YYYY') : '-';
    },
    formatCurrency(value) {
      return formatCurrency(value, 'Rp.') || '-';
    },
    getComparisonDataCustome(old_value, new_value) {
      // Memastikan old_value dan new_value bukan undefined atau null
      const oldValue = old_value || {};
      const newValue = new_value || {};

      const filterKeysMapping = (keys) => {
        return keys
          .filter(
            (key) =>
              !key.includes('id') && !key.includes('code_plan_budget') && !key.includes('code_actual_budget') && !key.includes('actual_budget_item')
          )
          .map((key) => {
            let transformedKey = key;
            if (transformedKey.includes('subject')) {
              transformedKey = transformedKey.replace(/subject/gi, 'number');
            }
            transformedKey = transformedKey.replace(/(po|pr|im|gl)/gi, (match) => match.toUpperCase());
            if (key == 'po_name') {
              transformedKey = 'PR Name';
            }
            if (key == 'im_number') {
              transformedKey = 'Internal Memo';
            }
            if (key == 'project_tag') {
              transformedKey = 'Project Tag';
            }
            return {
              original: key,
              transformed: transformedKey,
            };
          });
      };

      // Contoh pemakaian di kode pembanding data:
      const result = {};
      const oldMappings = filterKeysMapping(Object.keys(oldValue));
      const newMappings = filterKeysMapping(Object.keys(newValue));

      // Iterasi key dari oldValue
      oldMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        result[formattedKey] = {
          old_value: oldValue[mapping.original] || '-',
          new_value: newValue[mapping.original] || '-',
        };
      });

      // Tambahkan key yang ada di newValue tapi tidak di oldValue
      newMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        if (!result.hasOwnProperty(formattedKey)) {
          result[formattedKey] = {
            old_value: oldValue[mapping.original] || '-',
            new_value: newValue[mapping.original] || '-',
          };
        }
      });
      Object.keys(result).forEach((key) => {
        if (result[key].old_value === result[key].new_value) {
          delete result[key];
        }
      });

      return result;
    },
    getComparisonData(old_value, new_value) {
      // Memastikan old_value dan new_value bukan undefined atau null
      const oldValue = old_value || {};
      const newValue = new_value || {};

      const filterKeysMapping = (keys) => {
        return keys
          .filter(
            (key) =>
              !key.includes('id') && !key.includes('code_plan_budget') && !key.includes('code_actual_budget') && !key.includes('actual_budget_item')
          )
          .map((key) => {
            let transformedKey = key;
            if (transformedKey.includes('subject')) {
              transformedKey = transformedKey.replace(/subject/gi, 'number');
            }
            transformedKey = transformedKey.replace(/(po|pr|im|gl)/gi, (match) => match.toUpperCase());
            if (key == 'po_name') {
              transformedKey = 'PR Name';
            }
            if (key == 'im_number') {
              transformedKey = 'Internal Memo';
            }
            if (key == 'project_tag') {
              transformedKey = 'Project Tag';
            }

            return {
              original: key,
              transformed: transformedKey,
            };
          });
      };

      // Contoh pemakaian di kode pembanding data:
      const result = {};
      const oldMappings = filterKeysMapping(Object.keys(oldValue));
      const newMappings = filterKeysMapping(Object.keys(newValue));

      // Iterasi key dari oldValue
      oldMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        result[formattedKey] = {
          old_value: oldValue[mapping.original] || '-',
          new_value: newValue[mapping.original] || '-',
        };
      });

      // Tambahkan key yang ada di newValue tapi tidak di oldValue
      newMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        if (!result.hasOwnProperty(formattedKey)) {
          result[formattedKey] = {
            old_value: oldValue[mapping.original] || '-',
            new_value: newValue[mapping.original] || '-',
          };
        }
      });

      return result;
    },
    // Fungsi untuk mengubah key (mengganti "_" menjadi spasi dan kapitalisasi setiap kata)
    formatKey(key) {
      return key
        .replace(/_/g, ' ') // Ganti _ dengan spasi
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Kapitalisasi setiap awal kata
    },
    titleCase(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    deepDiffProject(oldValue, newValue) {
      if (!oldValue && !newValue) {
        return;
      } else if (!oldValue && newValue) {
        const newValueAdded =
          newValue?.map((item) => {
            const updatedRelocations = (item.project_relocations || [])?.map((relocate) => {
              return {
                ...relocate,
                added: true,
              };
            });
            return {
              ...item,
              added: true,
              project_relocations: updatedRelocations,
            };
          }) || {};
        this.projectAdded = newValueAdded;
        return;
      }
      const oldValueDeleted = oldValue?.map((oldItem) => {
        const newItem = newValue ? newValue.find((x) => x.id === oldItem.id) : newValue;
        // If whole item is deleted
        if (!newItem) {
          return {
            ...oldItem,
            deleted: true,
          };
        }

        // Handle nested project_relocations
        const updatedRelocations = (oldItem.project_relocations || []).map((relocate) => {
          const exists = newItem.project_relocations?.find((x) => x.id === relocate.id);

          if (!exists) {
            return {
              ...relocate,
              deleted: true,
            };
          }

          return relocate;
        });

        return {
          ...oldItem,
          project_relocations: updatedRelocations,
        };
      });

      const newValueAdded =
        newValue?.map((item) => {
          const newItem = oldValue?.find((x) => x.id === item.id);

          // If whole item is add
          if (!newItem) {
            return {
              ...item,
              added: true,
            };
          }

          // Handle nested project_relocations
          const updatedRelocations = (item.project_relocations || []).map((relocate) => {
            const exists = newItem?.project_relocations?.find((x) => x.id === relocate.id);
            if (!exists) {
              return {
                ...relocate,
                added: true,
              };
            }
            return relocate;
          });
          return {
            ...item,
            project_relocations: updatedRelocations,
          };
        }) || {};

      const tempDelete = oldValueDeleted?.filter((p) => p.deleted === true || p.project_relocations.some((r) => r.deleted === true));
      this.projectDeleted = tempDelete?.map((project) => ({
        ...project,
        project_relocations: project?.project_relocations?.filter((r) => r.deleted === true),
      }));
      this.projectAdded =
        newValueAdded && newValueAdded.length > 0
          ? (newValueAdded || []).filter((p) => p.added === true || p.project_relocations.some((r) => r.added === true))
          : newValueAdded;
      const oldValueDeletedExclude = oldValueDeleted && oldValueDeleted.length > 0 ? oldValueDeleted?.filter((x) => !x.deleted) : oldValueDeleted;
      const newValueAddedExlude = newValueAdded && newValueAdded.length > 0 ? newValueAdded?.filter((x) => !x.added) : newValueAdded;
      const oldChanges = oldValueDeletedExclude?.map((item) => {
        const newItem = newValueAddedExlude?.find((x) => x.id === item.id);
        if (newItem) {
          if (newItem.project_name !== item.project_name || newItem.relocate_value !== item.relocate_value) {
            item = {
              ...item,
              changes: true,
              project_name_new: newItem.project_name,
              relocate_value_new: newItem.relocate_value,
            };
          }
        }
        // Handle nested project_relocations
        const updatedRelocations = (item.project_relocations || [])?.map((relocate) => {
          const exists = newItem?.project_relocations?.find((b) => b.id === relocate.id);
          if (exists) {
            if (
              exists.relocate_value !== relocate.relocate_value ||
              exists?.budget_task_from_detail?.account_name !== relocate?.budget_task_from_detail?.account_name ||
              exists?.budget_task_from_detail?.budget_type !== relocate?.budget_task_from_detail?.budget_type ||
              exists?.budget_task_from_detail?.department_code !== relocate?.budget_task_from_detail?.department_code ||
              exists?.budget_task_from_detail?.fund_name !== relocate?.budget_task_from_detail?.fund_name ||
              exists?.budget_task_from_detail?.gl_code !== relocate?.budget_task_from_detail?.gl_code ||
              exists?.budget_task_from_detail?.code !== relocate?.budget_task_from_detail?.code ||
              exists?.budget_task_from_detail?.plan_id !== relocate?.budget_task_from_detail?.plan_id ||
              exists?.budget_task_to_detail?.account_name !== relocate?.budget_task_to_detail?.account_name ||
              exists?.budget_task_to_detail?.budget_type !== relocate?.budget_task_to_detail?.budget_type ||
              exists?.budget_task_to_detail?.department_code !== relocate?.budget_task_to_detail?.department_code ||
              exists?.budget_task_to_detail?.fund_name !== relocate?.budget_task_to_detail?.fund_name ||
              exists?.budget_task_to_detail?.gl_code !== relocate?.budget_task_to_detail?.gl_code ||
              exists?.budget_task_to_detail?.code !== relocate?.budget_task_to_detail?.code ||
              exists?.budget_task_to_detail?.plan_id !== relocate?.budget_task_to_detail?.plan_id
            ) {
              return {
                ...relocate,
                changes: true,
                old_value: relocate,
                new_value: exists,
              };
            }
          }
          return relocate;
        });

        return {
          ...item,
          project_relocations: updatedRelocations || {},
        };
      });
      this.projectChanged =
        oldChanges
          ?.map((p) => {
            const projectRelocations = (p.project_relocations || [])?.filter((r) => r.changes === true);

            if (p.changes === true || projectRelocations.length > 0) {
              return {
                ...p,
                project_relocations: projectRelocations,
              };
            }

            return null;
          })
          .filter(Boolean) || oldChanges;
    },
    deepDiff(oldObj, newObj, options = {}) {
      const { ignoredFields = ['created_at', 'updated_at', 'created_by', 'updated_by'], path = '', changes = [] } = options;

      const isObject = (val) => val && typeof val === 'object' && !Array.isArray(val);

      const buildPath = (base, key) => (base ? `${base}.${key}` : key);

      const keys = new Set([...Object.keys(oldObj || {}), ...Object.keys(newObj || {})]);

      for (const key of keys) {
        if (ignoredFields.includes(key)) continue;

        const oldVal = oldObj?.[key];
        const newVal = newObj?.[key];
        const currentPath = buildPath(path, key);

        // ===== ARRAY (by id) =====
        if (Array.isArray(oldVal) || Array.isArray(newVal)) {
          const oldArr = oldVal || [];
          const newArr = newVal || [];

          const mapById = (arr) =>
            arr.reduce((acc, item) => {
              acc[item.id] = item;
              return acc;
            }, {});

          const oldMap = mapById(oldArr);
          const newMap = mapById(newArr);

          const ids = new Set([...Object.keys(oldMap), ...Object.keys(newMap)]);

          for (const id of ids) {
            if (!oldMap[id]) {
              changes.push({
                type: 'added',
                path: `${currentPath}[id=${id}]`,
                newValue: newMap[id],
              });
            } else if (!newMap[id]) {
              changes.push({
                type: 'removed',
                path: `${currentPath}[id=${id}]`,
                oldValue: oldMap[id],
              });
            } else {
              this.deepDiff(oldMap[id], newMap[id], {
                ignoredFields,
                path: `${currentPath}[id=${id}]`,
                changes,
              });
            }
          }
          continue;
        }

        // ===== OBJECT =====
        if (isObject(oldVal) && isObject(newVal)) {
          this.deepDiff(oldVal, newVal, {
            ignoredFields,
            path: currentPath,
            changes,
          });
          continue;
        }

        // ===== PRIMITIVE =====
        if (oldVal !== newVal) {
          changes.push({
            type: 'changed',
            path: currentPath,
            oldValue: oldVal,
            newValue: newVal,
          });
        }
      }

      return changes;
    },
  },
};
</script>

<style>
.skeleton-loader {
  background-color: #e0e0e0;
  height: 20px;
  margin-bottom: 10px;
  border-radius: 4px;
}
</style>
